import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { routeConstants } from 'app/routes/route-constants';

export const getBackRoute = (id?: number, favouriteId?: number) =>
  isDefinedIncludingZero(id) && isDefinedIncludingZero(favouriteId)
    ? routeConstants.dashboardWithFavouriteFor(id, favouriteId)
    : routeConstants.dashboardAdminList;
